import { isWithinInterval, addHours } from "date-fns";

// TODO make it dynamic with orga parameter
export const isInNext24Hours = (date: Date) => {
  const now = new Date();
  const next24Hours = addHours(now, 12); // Is now 12 hours

  return isWithinInterval(date, {
    start: now,
    end: next24Hours,
  });
};
